export const stlDigitalCompanyCodeList = [
    { value: '1000', label: '1000 - STL Digital Ltd.' },
    { value: '2000', label: '2000 - STL Digital Inc.' },
    { value: '3000', label: '3000 - STL Digital UK Ltd.' }
];

export const stlDigitalPurchasingOrgList = [
    { value: '1000', label: '1000 - STL Digital Ltd.' },
    { value: '2000', label: '2000 - STL Digital Inc.' },
    { value: '3000', label: '3000 - STL Digital UK Ltd.' }
];

export const stlDigitalPaymentTermsList = [
    { code: '0001', desc: 'Payable immediately Due net' },
    { code: '0002', desc: '1.within 14 days 2 % cash discount\n2.within 30 days Due net' },
    { code: '0003', desc: 'within 14 days 3 % cash discount\nwithin 20 days 2 % cash discount\nwithin 30 days Due net' },
    { code: '0004', desc: 'Payable immediately Due net\nBaseline date on End of the month' },
    { code: '0005', desc: 'Payable immediately Due net\nBaseline date on 10 of next month' },
    { code: '0006', desc: 'Before End of the month 4 % cash discount\nBefore 15 of the next month ;; 2 % cash discount\nBefore 15 in 2 months Due net' },
    { code: '0007', desc: '1.For incoming invoices until 15 of the month\n2.Before 15 of the next month ;; 2 % cash discount\n3.Before End of the next month ;; Due net\n4. For incoming invoices until End of the month\n5.Before End of the next month ;; 2 % cash discoun\n6.Before 15 in 2 months Due net' },
    { code: '0008', desc: '1.For incoming invoices until 15 of the month\n2.within 14 days 2 % cash discount\n3.within 30 days 1.5 % cash discount\n4.within 45 days Due net\n5.Baseline date on 30 of the month\n6.For incoming invoices until End of the month\n7.within 14 days 2 % cash discount\n8.within 30 days 1.5 % cash discount\n9.within 45 days Due net\n10.Baseline date on 15 of next month' },
    { code: '0009', desc: 'Payable in 3 partial amounts\n1 installment: 30.000 % with payment term NT60\n2 installment: 40.000 % with payment term NT30\n3 installment: 30.000 % with payment term 0001' },
    { code: '005A', desc: '20%PO,30%beforedispatch&50%after15daysfromDelvry' },
    { code: '005B', desc: '20%PO,30%beforedispatch&50%after15daysfromDelvry' },
    { code: '005C', desc: '20%PO,30%beforedispatch&50%after15daysfromDelvry' },
    { code: '007A', desc: '95% on supply, Balance 5% afer 6 months of supply' },
    { code: '007B', desc: '95% on supply, Balance 5% afer 6 months of supply' },
    { code: '008A', desc: '5% Adv. against ABG balance 95% against LC 30 days' },
    { code: '008B', desc: '5% Adv. against ABG balance 95% against LC 30 days' },
    { code: '009A', desc: '5% Adv. against ABG balance 95% against LC 90 days' },
    { code: '009B', desc: '5% Adv. against ABG balance 95% against LC 90 days' },
    { code: '010A', desc: '14%Adv with PO,68%180 days BG &19%Adv before displ' },
    { code: '010B', desc: '14%Adv with PO,68%180 days BG &18%Adv before displ' },
    { code: '010C', desc: '14%Adv with PO,68%180 days BG &18%Adv before displ' },
    { code: '011A', desc: '30% Advance & 70% 30 days PDC cheque' },
    { code: '011B', desc: '30% Advance & 70% 30 days PDC cheque' },
    { code: '018A', desc: '30% Adv & Bal. 70% 60 days from Invoice date' },
    { code: '018B', desc: '30% Adv & Bal. 70% 60 days from Invoice date' },
    { code: '040A', desc: '25 % Advance 75% in 30 days' },
    { code: '040B', desc: '25 % Advance 75% in 30 days' },
    { code: '045A', desc: 'Ramky 5 % Advace 95% within 90 days LC' },
    { code: '045B', desc: 'Ramky 5 % Advace 95% within 90 days LC' },
    { code: '046A', desc: '5% Adv and 95% on 60th day of of mat. receipt' },
    { code: '046B', desc: '5% Adv and 95% on 60th day of of mat. receipt' },
    { code: '11A', desc: '50% Advance' },
    { code: '11B', desc: '50% Remaining' },
    { code: 'C001', desc: '20 Days Open Credit' },
    { code: 'C002', desc: 'Within 75 days Due net' },
    { code: 'C003', desc: 'Within 90 days Due net' },
    { code: 'C004', desc: '30 days from date of Delivery against BG' },
    { code: 'C005', desc: '20%PO,30%beforedispatch&50%after15daysfromDelvry' },
    { code: 'C006', desc: '270 Days Credit from the date of delivery' },
    { code: 'C007', desc: '95% on supply, Balance 5% afer 6 months of supply' },
    { code: 'C008', desc: '5% Adv. against ABG balance 95% against LC 30 days' },
    { code: 'C009', desc: '5% Adv. against ABG balance 95% against LC 90 days' },
    { code: 'C010', desc: '14%Adv with PO,68%180 days BG &19%Adv before displ' },
    { code: 'C011', desc: '30% Advance & 70% 30 days PDC cheque' },
    { code: 'C012', desc: '7% Advance' },
    { code: 'C013', desc: '10% Advance' },
    { code: 'C014', desc: '15% Advance' },
    { code: 'C015', desc: '20% Advance' },
    { code: 'C016', desc: '25% Advance' },
    { code: 'C017', desc: '28% Advance' },
    { code: 'C018', desc: '30% Adv & Bal. 70% 60 days from Invoice date' },
    { code: 'C019', desc: '40% Advance' },
    { code: 'C020', desc: '50% Advance' },
    { code: 'C021', desc: '20%advTT' },
    { code: 'C022', desc: '93% LC 60 days' },
    { code: 'C023', desc: '80%D/A 60days B/L dt' },
    { code: 'C024', desc: '60% Advance' },
    { code: 'C025', desc: '65% Advance' },
    { code: 'C026', desc: '5% Advance' },
    { code: 'C027', desc: '30 Days ARO' },
    { code: 'C028', desc: '100% Advance' },
    { code: 'C029', desc: '50 % CAD basis' },
    { code: 'C030', desc: '100 % CAD basis' },
    { code: 'C031', desc: '75 % CAD basis' },
    { code: 'C032', desc: '80 % CAD basis' },
    { code: 'C033', desc: '10% Adv & 90% CAD' },
    { code: 'C034', desc: '100 % CAD 90 Days' },
    { code: 'C035', desc: '100 % COD basis' },
    { code: 'C036', desc: '100 % CAD 30 Days' },
    { code: 'C037', desc: '100 % Advance By TT' },
    { code: 'C038', desc: '90 % Advance' },
    { code: 'C039', desc: '95 % Advance' },
    { code: 'C040', desc: '25 % Advance 75% in 30 days' },
    { code: 'C041', desc: '20% After Inspection 60 days' },
    { code: 'C043', desc: 'Within 70 days Due net' },
    { code: 'C044', desc: 'Payable immediately Due net' },
    { code: 'C045', desc: 'Ramky 5 % Advace 95% within 90 days LC' },
    { code: 'C046', desc: '5% Adv and 95% on 60th day of of mat. receipt' },
    { code: 'C047', desc: '5 % Advance' },
    { code: 'C048', desc: '95% Against LC with 90 days' },
    { code: 'C049', desc: 'Payable in 5 partial amounts' },
    { code: 'C050', desc: 'Within 15 days Due net' },
    { code: 'C051', desc: 'Within 30 days Due net' },
    { code: 'C052', desc: 'Within 60 days Due net' },
    { code: 'C053', desc: 'Within 120 days Due net' },
    { code: 'C054', desc: 'Within 150 days Due net' },
    { code: 'C055', desc: 'Within 180 days Due net' },
    { code: 'C060', desc: 'Within 60 days due net' },
    { code: 'C110', desc: 'Within 110 days due net' },
    { code: 'NT00', desc: 'Payable immediately Due net' },
    { code: 'NT08', desc: 'within 8 days Due net' },
    { code: 'NT15', desc: 'within 15 days Due net' },
    { code: 'NT30', desc: 'within 30 days Due net' },
    { code: 'NT45', desc: 'within 45 days Due net' },
    { code: 'NT60', desc: 'within 60 days Due net' },
    { code: 'V001', desc: 'Immediate; 0 days Credit' },
    { code: 'V002', desc: 'Immediate; 0 days Credit' },
    { code: 'V003', desc: '30 Days Due net' },
    { code: 'V004', desc: '15 Days Due net.' },
    { code: 'V005', desc: '60 Days Due net' },
    { code: 'V006', desc: '75 Days Due net' },
    { code: 'V007', desc: '7 Days Due net' },
    { code: 'V008', desc: '45 Days Due net' },
    { code: 'V009', desc: '180 Days Due net' },
    { code: 'V010', desc: '60 Days Due net' },
    { code: 'V011', desc: '50% Advance & 50% Remaining' },
    { code: 'V012', desc: '100 % Advance with PO' },
    { code: 'V013', desc: '45 Days from the date of Invoice' },
    { code: 'V014', desc: 'Net 90 Days from date of Invoice' },
    { code: 'V015', desc: 'Net 30 Days from Date of Invoice' },
    { code: 'V016', desc: 'Net 60 Days from Date of Invoice' },
    { code: 'V017', desc: '100 % Advance' },
];

export const stlDigitalCurrencyList = [
    { code: 'AED', desc: 'United Arab Emirates Dirham' },
    { code: 'AFN', desc: 'Afghani' },
    { code: 'ALL', desc: 'Albanian Lek' },
    { code: 'AMD', desc: 'Armenian Dram' },
    { code: 'ANG', desc: 'Netherlands Antillean Guilder' },
    { code: 'AOA', desc: 'Angolanische Kwanza' },
    { code: 'ARS', desc: 'Argentine Peso' },
    { code: 'AUD', desc: 'Australian Dollar' },
    { code: 'AWG', desc: 'Aruban Florin' },
    { code: 'AZN', desc: 'Azerbaijan Manat' },
    { code: 'BAM', desc: 'Bosnia and Herzegovina Convertible Mark' },
    { code: 'BBD', desc: 'Barbados Dollar' },
    { code: 'BDT', desc: 'Bangladesh Taka' },
    { code: 'BGN', desc: 'Bulgarian Lev' },
    { code: 'BHD', desc: 'Bahrain Dinar' },
    { code: 'BIF', desc: 'Burundi Franc' },
    { code: 'BMD', desc: 'Bermudan Dollar' },
    { code: 'BND', desc: 'Brunei Dollar' },
    { code: 'BOB', desc: 'Boliviano' },
    { code: 'BRL', desc: 'Brazilian Real' },
    { code: 'BSD', desc: 'Bahaman Dollar' },
    { code: 'BTN', desc: 'Bhutan Ngultrum' },
    { code: 'BWP', desc: 'Botswana Pula' },
    { code: 'BYN', desc: 'Belarusian Ruble' },
    { code: 'BYR', desc: 'Belorussian Ruble' },
    { code: 'BZD', desc: 'Belize Dollar' },
    { code: 'CAD', desc: 'Canadian Dollar' },
    { code: 'CDF', desc: 'Congolese Franc' },
    { code: 'CHF', desc: 'Swiss Franc' },
    { code: 'CLF', desc: 'Chile Unidad de Fomento' },
    { code: 'CLP', desc: 'Chilean Peso' },
    { code: 'CNY', desc: 'Chinese Yuan Renminbi' },
    { code: 'COP', desc: 'Colombian Peso' },
    { code: 'CRC', desc: 'Costa Rica Colon' },
    { code: 'CUC', desc: 'Peso Convertible' },
    { code: 'CUP', desc: 'Cuban Peso' },
    { code: 'CVE', desc: 'Cape Verde Escudo' },
    { code: 'CZK', desc: 'Czech Krona' },
    { code: 'DJF', desc: 'Djibouti Franc' },
    { code: 'DKK', desc: 'Danish Krone' },
    { code: 'DOP', desc: 'Dominican Peso' },
    { code: 'DZD', desc: 'Algerian Dinar' },
    { code: 'EGP', desc: 'Egyptian Pound' },
    { code: 'ERN', desc: 'Eritrean Nafka' },
    { code: 'ETB', desc: 'Ethiopian Birr' },
    { code: 'EUR', desc: 'European Euro' },
    { code: 'FJD', desc: 'Fiji Dollar' },
    { code: 'FKP', desc: 'Falkland Pound' },
    { code: 'GBP', desc: 'British Pound' },
    { code: 'GEL', desc: 'Georgian Lari' },
    { code: 'GHS', desc: 'Ghanian Cedi' },
    { code: 'GIP', desc: 'Gibraltar Pound' },
    { code: 'GMD', desc: 'Gambian Dalasi' },
    { code: 'GNF', desc: 'Guinean Franc' },
    { code: 'GTQ', desc: 'Guatemalan Quetzal' },
    { code: 'GYD', desc: 'Guyana Dollar' },
    { code: 'HKD', desc: 'Hong Kong Dollar' },
    { code: 'HNL', desc: 'Honduran Lempira' },
    { code: 'HRK', desc: 'Croatian Kuna' },
    { code: 'HTG', desc: 'Haitian Gourde' },
    { code: 'HUF', desc: 'Hungarian Forint' },
    { code: 'IDR', desc: 'Indonesian Rupiah' },
    { code: 'ILS', desc: 'Israeli Shekel' },
    { code: 'INR', desc: 'Indian Rupee' },
    { code: 'IQD', desc: 'Iraqui Dinar' },
    { code: 'IRR', desc: 'Iranian Rial' },
    { code: 'ISK', desc: 'Iceland Krona' },
    { code: 'JMD', desc: 'Jamaican Dollar' },
    { code: 'JOD', desc: 'Jordanian Dinar' },
    { code: 'JPY', desc: 'Japanese Yen' },
    { code: 'KES', desc: 'Kenyan Shilling' },
    { code: 'KGS', desc: 'Kyrgyzstan Som' },
    { code: 'KHR', desc: 'Cambodian Riel' },
    { code: 'KMF', desc: 'Comoros Franc' },
    { code: 'KPW', desc: 'North Korean Won' },
    { code: 'KRW', desc: 'South Korean Won' },
    { code: 'KWD', desc: 'Kuwaiti Dinar' },
    { code: 'KYD', desc: 'Cayman Dollar' },
    { code: 'KZT', desc: 'Kazakstanian Tenge' },
    { code: 'LAK', desc: 'Laotian Kip' },
    { code: 'LBP', desc: 'Lebanese Pound' },
    { code: 'LKR', desc: 'Sri Lankan Rupee' },
    { code: 'LRD', desc: 'Liberian Dollar' },
    { code: 'LSL', desc: 'Lesotho Loti' },
    { code: 'LYD', desc: 'Libyan Dinar' },
    { code: 'MAD', desc: 'Moroccan Dirham' },
    { code: 'MDL', desc: 'Moldavian Leu' },
    { code: 'MGA', desc: 'Madagascan Ariary' },
    { code: 'MKD', desc: 'Macedonian Denar' },
    { code: 'MMK', desc: 'Myanmar Kyat' },
    { code: 'MNT', desc: 'Mongolian Tugrik' },
    { code: 'MOP', desc: 'Macao Pataca' },
    { code: 'MRU', desc: 'Mauritanian Ouguiya' },
    { code: 'MUR', desc: 'Mauritian Rupee' },
    { code: 'MVR', desc: 'Maldive Rufiyaa' },
    { code: 'MWK', desc: 'Malawi Kwacha' },
    { code: 'MXN', desc: 'Mexican Pesos' },
    { code: 'MXV', desc: 'Mexic Unidad de Inversion' },
    { code: 'MYR', desc: 'Malaysian Ringgit' },
    { code: 'MZN', desc: 'Mozambique Metical' },
    { code: 'NAD', desc: 'Namibian Dollar' },
    { code: 'NGN', desc: 'Nigerian Naira' },
    { code: 'NIO', desc: 'Nicaraguan Cordoba Oro' },
    { code: 'NOK', desc: 'Norwegian Krone' },
    { code: 'NPR', desc: 'Nepalese Rupee' },
    { code: 'NZD', desc: 'New Zealand Dollars' },
    { code: 'OMR', desc: 'Omani Rial' },
    { code: 'PAB', desc: 'Panamanian Balboa' },
    { code: 'PEN', desc: 'Peruvian New Sol' },
    { code: 'PGK', desc: 'Papua New Guinea Kina' },
    { code: 'PHP', desc: 'Philippine Peso' },
    { code: 'PKR', desc: 'Pakistani Rupee' },
    { code: 'PLN', desc: 'Polish Zloty' },
    { code: 'PYG', desc: 'Paraguayan Guarani' },
    { code: 'QAR', desc: 'Qatar Rial' },
    { code: 'RON', desc: 'Romanian Leu' },
    { code: 'RSD', desc: 'Serbian Dinar' },
    { code: 'RUB', desc: 'Russian Ruble' },
    { code: 'RWF', desc: 'Rwandan Franc' },
    { code: 'SAR', desc: 'Saudi Riyal' },
    { code: 'SBD', desc: 'Solomon Islands Dollar' },
    { code: 'SCR', desc: 'Seychelles Rupee' },
    { code: 'SDG', desc: 'Sudanese Pound' },
    { code: 'SEK', desc: 'Swedish Krona' },
    { code: 'SGD', desc: 'Singapore Dollar' },
    { code: 'SHP', desc: 'St.Helena Pound' },
    { code: 'SLE', desc: 'Sierra Leone Leone' },
    { code: 'SOS', desc: 'Somalian Shilling' },
    { code: 'SRD', desc: 'Surinam Dollar' },
    { code: 'SSP', desc: 'South Sudanese Pound' },
    { code: 'STN', desc: 'Sao Tome / Principe Dobra' },
    { code: 'SVC', desc: 'El Salvador Colon' },
    { code: 'SYP', desc: 'Syrian Pound' },
    { code: 'SZL', desc: 'Swaziland Lilangeni' },
    { code: 'THB', desc: 'Thailand Baht' },
    { code: 'TJS', desc: 'Tajikistani Somoni' },
    { code: 'TMT', desc: 'Turkmenistani Manat' },
    { code: 'TND', desc: 'Tunisian Dinar' },
    { code: 'TOP', desc: 'Tongan Pa\'anga' },
    { code: 'TRY', desc: 'Turkish Lira' },
    { code: 'TTD', desc: 'Trinidad and Tobago Dollar' },
    { code: 'TWD', desc: 'New Taiwan Dollar' },
    { code: 'TZS', desc: 'Tanzanian Shilling' },
    { code: 'UAH', desc: 'Ukraine Hryvnia' },
    { code: 'UGX', desc: 'Ugandan Shilling' },
    { code: 'USD', desc: 'United States Dollar' },
    { code: 'UYU', desc: 'Uruguayan Peso' },
    { code: 'UZS', desc: 'Uzbekistan Som' },
    { code: 'VEF', desc: 'Venezuelan Bolivar' },
    { code: 'VES', desc: 'Bolivar Soberano' },
    { code: 'VND', desc: 'Vietnamese Dong' },
    { code: 'VUV', desc: 'Vanuatu Vatu' },
    { code: 'WST', desc: 'Samoan Tala' },
    { code: 'XAD', desc: 'Arab Accounting Dinar' },
    { code: 'XAF', desc: 'Gabon CFA Franc BEAC' },
    { code: 'XCD', desc: 'East Carribean Dollar' },
    { code: 'XCG', desc: 'Caribbean Guilder' },
    { code: 'XOF', desc: 'Benin CFA Franc BCEAO' },
    { code: 'XPF', desc: 'CFP Franc' },
    { code: 'YER', desc: 'Yemeni Ryal' },
    { code: 'ZAR', desc: 'South African Rand' },
    { code: 'ZMW', desc: 'Zambian Kwacha' },
    { code: 'ZWG', desc: 'Zimbabwean Gold' },
    { code: 'ZWL', desc: 'Zimbabwean Dollar' }
];

export const stlDigitalIncoTermsList = [
    { code: 'CFR', desc: 'Costs and Freight' },
    { code: 'CIF', desc: 'Costs, Insurance & Freight' },
    { code: 'CIP', desc: 'Carriage and Insurance Paid to' },
    { code: 'CPT', desc: 'Carriage Paid to' },
    { code: 'DAF', desc: 'Delivered at Frontier' },
    { code: 'DAP', desc: 'Delivered at Place' },
    { code: 'DAT', desc: 'Delivered at Terminal' },
    { code: 'DDP', desc: 'Delivered Duty Paid' },
    { code: 'DDU', desc: 'Delivered Duty Unpaid' },
    { code: 'DEQ', desc: 'Delivered ex Quay (duty paid)' },
    { code: 'DES', desc: 'Delivered ex Ship' },
    { code: 'DPU', desc: 'Delivered at Place Unloaded' },
    { code: 'EDL', desc: 'Electronic Delivery' },
    { code: 'EXW', desc: 'Ex Works' },
    { code: 'FAS', desc: 'Free Alongside Ship' },
    { code: 'FCA', desc: 'Free Carrier' },
    { code: 'FH', desc: 'Free House' },
    { code: 'FOB', desc: 'Free on Board' },
    { code: 'NA', desc: 'Not Applicable' },
    { code: 'UN', desc: 'Not Free' }
];

export const stlDigitalPaymentMethodList = [
    { code: 'C', desc: 'Check' },
    { code: 'F', desc: 'Foreign Bank Transfer' },
    { code: 'T', desc: 'Bank Transfer' }
];
